import { Component } from 'utils/jsx'
import cuid from 'cuid'

import Button from 'components/dom/Button'

export default class InputFile extends Component {
  beforeRender () {
    this.handleClick = this.handleClick.bind(this)
    this.handleChange = this.handleChange.bind(this)
  }

  template (props) {
    return (
      <div class='input-file'>
        <input
          ref={this.ref('input')}
          id={props.id || cuid()}
          type='file'
          style='display: none'
          accept={props.accept || '*'}
          multiple={props.multiple}
          event-change={this.handleChange}
        />
        <Button
          icon='plus'
          class='file-upload'
          ref={this.ref('button')}
          event-click={this.handleClick}
        >
          {props.children}
        </Button>
      </div>
    )
  }

  handleClick () {
    this.refs.input.click()
  }

  get files () {
    return this.mounted && this.refs.input.files
  }

  handleChange () {
    if (!this.files || !this.files.length) return
    if (!this.props['event-change']) {
      console.warn('No event-change prop defined')
      return
    }

    this.props['event-change'](Array.from(this.files))
    this.refs.input.value = null
  }
}



// WEBPACK FOOTER //
// ./src/components/dom/InputFile.js